"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FullScreenLoaderStyle = void 0;
const styled_1 = __importDefault(require("@emotion/styled"));
const ui_theme_1 = require("@kyruus/ui-theme");
exports.FullScreenLoaderStyle = styled_1.default.div `
  width: 100%;
  height: 100vh;
  position: fixed;
  right: 0;
  top: 0;
  opacity: 0.72;
  background: ${(0, ui_theme_1.fromTheme)('color_background')};
  z-index: 1000;
  display: flex;
  justify-content: center;
  align-items: center;
`;
//# sourceMappingURL=styles.js.map